import { makeActionCreator } from '../../../utilities'
import { PatientAllergiesConstants } from './patientAllergies.constants'

export const saveAllergies = makeActionCreator(PatientAllergiesConstants.SAVE_ALLERGIES, 'allergies')
export const setPatientAllergies = makeActionCreator(
  PatientAllergiesConstants.SET_PATIENT_ALLERGIES,
  'patientAllergies'
)
export const setSavePatientAllergiesResponse = makeActionCreator(PatientAllergiesConstants.SET_RESPONSE, 'response')
export const resetPatientAllergiesState = makeActionCreator(PatientAllergiesConstants.RESET_STATE)
export const deletePatientAllergy = makeActionCreator(PatientAllergiesConstants.DELETE_ALLERGY, 'allergy')
export const getAllergiesOptions = makeActionCreator(PatientAllergiesConstants.GET_PATIENT_ALLERGIES_OPTIONS)
export const setIsLoading = makeActionCreator(PatientAllergiesConstants.SET_IS_LOADING, 'isLoading')
